import { ApiResourceMethod } from '@/api/api-requests-factory';
import { BaseResponse } from '@/api/api-requests-factory/models/response.model';

export default class DeleteGeoPaymentMethodRequest
  extends ApiResourceMethod<{}> {
  public perform(billingPaymentMethodSettingsId: string): Promise<{}> {
    return this.performer.requestWithMapper(
      {
        url: `${billingPaymentMethodSettingsId}`,
        data: { billingPaymentMethodSettingsId },
      },
      (response: BaseResponse<{}>) => {
        return response.data;
      },
    );
  }
}
